// Copy for the Operations Campaign Actions box and its dialogs.
const TEXT = {
  ar: {
    boxTitle: "إجراءات الحملات",
    activateTitle: "تفعيل حملة",
    confirmUpdate: "تأكيد التعديل",
    confirmUpdateText: "راجع التعديلات ثم أكّد حفظها.",
    back: "رجوع",
    cancelTitle: "إلغاء حملة",
    deleteTitle: "حذف حملة",
    deletedTitle: "الحملات المحذوفة",
    close: "إغلاق",
    store: "المتجر",
    stores: "المتاجر",
    app: "التطبيق",
    selectStore: "اختر المتجر",
    selectApp: "اختر التطبيق",
    fromCatalog: "اختيار حملة",
    manual: "إضافة حملة يدويًا",
    campaignName: "اسم الحملة",
    campaignType: "نوع الحملة",
    campaignDetails: "تفاصيل الحملة",
    notes: "ملاحظات (اختياري)",
    initialState: "حالة الحملة",
    stateRequest: "طلب جديد",
    stateActive: "فعالة حاليًا",
    stateRequestHint: "ستمر الحملة بمسار الموافقة والتفعيل المعتاد.",
    stateActiveHint: "تُسجَّل كحملة فعالة بالفعل دون طلب تفعيل جديد، ويمكن إلغاؤها لاحقًا.",
    startDate: "تاريخ البداية (اختياري)",
    endDate: "تاريخ النهاية (اختياري)",
    datesHint: "التواريخ اختيارية ويمكن إضافتها أو تعديلها لاحقًا.",
    submitRequest: "إرسال الطلب",
    submitActive: "تسجيل كحملة فعالة",
    submitting: "جارٍ الإرسال...",
    search: "ابحث بالاسم أو التطبيق أو المتجر",
    allTypes: "كل الأنواع",
    prev: "السابق",
    next: "التالي",
    page: (page, pages) => `صفحة ${page} من ${pages}`,
    results: (n) => `${n} حملة`,
    selectAll: (n) => `تحديد الكل (${n})`,
    selectedCount: (n) => `${n} محددة`,
    restaurants: "المطاعم",
    searchRestaurants: "ابحث عن مطعم",
    noEligibleActivate: "لا توجد مطاعم متاحة لديك لهذه الحملة.",
    viewInOperations: "عرض في العمليات",
    requestsTitle: "طلبات الحملة",
    requestsMenu: "حالة الطلبات",
    noRequests: "لا توجد طلبات لهذه الحملة بعد.",
    requestsCount: (n) => `${n} طلب`,
    more: (n) => `+${n}`,
    statusOverviewTitle: "حالة طلبات الحملات",
    noCampaignsWithStatus: "لا توجد حملات لها طلبات بعد.",
    backToList: "العودة إلى القائمة",
    editDates: "تعديل التواريخ",
    noDates: "بدون تواريخ",
    nameTooLong: (max, n) => `يجب ألا يزيد اسم الحملة عن ${max} حرفًا (الحالي ${n})`,
    progress: (done, total) => `جارٍ التنفيذ ${done} من ${total}...`,
    bulkPartial: (ok, total) => `تم تنفيذ ${ok} من ${total} فقط. فشلت الحملات التالية:`,
    bulkFailed: "لم يتم تنفيذ أي حملة. فشلت الحملات التالية:",
    cancelConfirmMany: (n) => `إلغاء ${n} حملة`,
    deleteConfirmMany: (n) => `حذف ${n} طلب`,
    noCatalog: "لا توجد حملات في القائمة لهذا التطبيق.",
    chooseAppFirst: "اختر التطبيق لعرض حملاته.",
    noActive: "لا توجد طلبات معتمدة بانتظار التفعيل يمكن إلغاؤها.",
    noDeletable: "لا توجد طلبات حملات جديدة قابلة للحذف.",
    noDeleted: "لا توجد حملات محذوفة.",
    noMatches: "لا توجد نتائج مطابقة.",
    chooseStoreFirst: "اختر المتجر لعرض حملاته.",
    loading: "جارٍ التحميل...",
    loadError: "تعذر تحميل الحملات",
    retry: "إعادة المحاولة",
    cancelReason: "سبب الإلغاء (اختياري)",
    cancelConfirm: "إرسال طلب الإلغاء",
    cancelWarning: "ستتحول الحملة إلى «ملغي» مع الاحتفاظ بسجلها.",
    deleteConfirm: "حذف الطلب",
    deleteWarning: "سينتقل الطلب إلى الحملات المحذوفة مع الاحتفاظ بسجله.",
    deletedOn: "حُذفت في",
    from: "من",
    to: "إلى",
    alreadyActive: "فعالة منذ الإدخال",
    editCampaign: "تعديل الحملة",
    save: "حفظ التعديلات",
    saving: "جارٍ الحفظ...",
    editTypeLocked: "لا يمكن تغيير النوع بعد بدء الطلب.",
    errors: {
      403: "ليست لديك صلاحية تنفيذ هذا الإجراء على هذا المتجر.",
      404: "لم يتم العثور على الحملة.",
      409: "تغيّرت حالة الحملة ولم يعد هذا الإجراء متاحًا. حدّث الصفحة.",
      generic: "تعذر تنفيذ الطلب. حاول مرة أخرى.",
    },
    required: "الحقول المطلوبة: اسم الحملة، النوع، والتفاصيل.",
    chooseCampaign: "اختر حملة للمتابعة.",
    chooseStores: "اختر متجرًا واحدًا على الأقل وتطبيقًا.",
  },
  en: {
    boxTitle: "Campaign Actions",
    activateTitle: "Activate Campaign",
    confirmUpdate: "Confirm update",
    confirmUpdateText: "Review your changes, then confirm to save them.",
    back: "Back",
    cancelTitle: "Cancel Campaign",
    deleteTitle: "Delete Campaign",
    deletedTitle: "Deleted Campaigns",
    close: "Close",
    store: "Store",
    stores: "Stores",
    app: "App",
    selectStore: "Select a store",
    selectApp: "Select an app",
    fromCatalog: "Choose a campaign",
    manual: "Add manually",
    campaignName: "Campaign Name",
    campaignType: "Campaign Type",
    campaignDetails: "Campaign Details",
    notes: "Notes (optional)",
    initialState: "Campaign state",
    stateRequest: "New Request",
    stateActive: "Currently Active",
    stateRequestHint: "The campaign follows the normal approval and activation workflow.",
    stateActiveHint: "Recorded as already active, with no new activation request. It can be cancelled later.",
    startDate: "Start Date (optional)",
    endDate: "End Date (optional)",
    datesHint: "Dates are optional and can be added or changed later.",
    submitRequest: "Submit request",
    submitActive: "Record as active",
    submitting: "Submitting...",
    search: "Search by name, app or store",
    allTypes: "All types",
    prev: "Previous",
    next: "Next",
    page: (page, pages) => `Page ${page} of ${pages}`,
    results: (n) => `${n} campaign${n === 1 ? "" : "s"}`,
    selectAll: (n) => `Select all (${n})`,
    selectedCount: (n) => `${n} selected`,
    restaurants: "Restaurants",
    searchRestaurants: "Search restaurants",
    noEligibleActivate: "None of your restaurants can use this campaign.",
    viewInOperations: "View in Operations",
    requestsTitle: "Campaign requests",
    requestsMenu: "Request status",
    noRequests: "This campaign has no requests yet.",
    requestsCount: (n) => `${n} request${n === 1 ? "" : "s"}`,
    more: (n) => `+${n}`,
    statusOverviewTitle: "Campaign request status",
    noCampaignsWithStatus: "No campaigns have requests yet.",
    backToList: "Back to list",
    editDates: "Edit dates",
    noDates: "No dates",
    nameTooLong: (max, n) => `Campaign name must be at most ${max} characters (it is ${n})`,
    progress: (done, total) => `Processing ${done} of ${total}...`,
    bulkPartial: (ok, total) => `Only ${ok} of ${total} completed. These campaigns failed:`,
    bulkFailed: "Nothing was completed. These campaigns failed:",
    cancelConfirmMany: (n) => `Cancel ${n} campaign${n === 1 ? "" : "s"}`,
    deleteConfirmMany: (n) => `Delete ${n} request${n === 1 ? "" : "s"}`,
    noCatalog: "No campaigns are listed for this app.",
    chooseAppFirst: "Choose an app to see its campaigns.",
    noActive: "There are no approved requests waiting for activation that can be canceled.",
    noDeletable: "There are no new campaign requests that can be deleted.",
    noDeleted: "There are no deleted campaigns.",
    noMatches: "No matching campaigns.",
    chooseStoreFirst: "Choose a store to see its campaigns.",
    loading: "Loading...",
    loadError: "Campaigns could not be loaded",
    retry: "Try again",
    cancelReason: "Cancellation reason (optional)",
    cancelConfirm: "Submit cancellation",
    cancelWarning: "The campaign becomes Canceled and its history is kept.",
    deleteConfirm: "Delete request",
    deleteWarning: "The request moves to Deleted Campaigns and its history is kept.",
    deletedOn: "Deleted on",
    from: "From",
    to: "To",
    alreadyActive: "Active since entry",
    editCampaign: "Edit campaign",
    save: "Save changes",
    saving: "Saving...",
    editTypeLocked: "The type cannot change once the request has started.",
    errors: {
      403: "You do not have permission to do this for this store.",
      404: "The campaign was not found.",
      409: "The campaign changed and this action is no longer available. Refresh the page.",
      generic: "The request could not be completed. Please try again.",
    },
    required: "Campaign name, type and details are required.",
    chooseCampaign: "Choose a campaign to continue.",
    chooseStores: "Choose at least one store and an app.",
  },
};

export const getCampaignText = (lang) => TEXT[lang] || TEXT.ar;
